module.exports = __webpack_public_path__ + "static/media/живая-музыка.4073978d.jpg";